export default __webpack_public_path__ + "src/assets/downloads/water.mp3";